/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { BatchSmsJob } from '../model/batchSmsJob';
import { BatchSmsJobDto } from '../model/batchSmsJobDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class BatchSmsJobService {

    protected basePath = 'http://10.1.1.123:30116';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public batchSmsJobAddBatchSmsJob(model: BatchSmsJob, observe?: 'body', reportProgress?: boolean): Observable<BatchSmsJob>;
    public batchSmsJobAddBatchSmsJob(model: BatchSmsJob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BatchSmsJob>>;
    public batchSmsJobAddBatchSmsJob(model: BatchSmsJob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BatchSmsJob>>;
    public batchSmsJobAddBatchSmsJob(model: BatchSmsJob, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling batchSmsJobAddBatchSmsJob.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<BatchSmsJob>(`${this.basePath}/api/BatchSmsJob/AddBatchSmsJob`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public batchSmsJobDelete(model: BatchSmsJob, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public batchSmsJobDelete(model: BatchSmsJob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public batchSmsJobDelete(model: BatchSmsJob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public batchSmsJobDelete(model: BatchSmsJob, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling batchSmsJobDelete.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post(`${this.basePath}/api/BatchSmsJob/Delete`,
            model,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param creatorId 
     * @param searchWord 
     * @param senderId 
     * @param startDate 
     * @param endDate 
     * @param startIndex 
     * @param count 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public batchSmsJobGetAll(creatorId?: string, searchWord?: string, senderId?: string, startDate?: Date, endDate?: Date, startIndex?: number, count?: number, observe?: 'body', reportProgress?: boolean): Observable<BatchSmsJobDto>;
    public batchSmsJobGetAll(creatorId?: string, searchWord?: string, senderId?: string, startDate?: Date, endDate?: Date, startIndex?: number, count?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BatchSmsJobDto>>;
    public batchSmsJobGetAll(creatorId?: string, searchWord?: string, senderId?: string, startDate?: Date, endDate?: Date, startIndex?: number, count?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BatchSmsJobDto>>;
    public batchSmsJobGetAll(creatorId?: string, searchWord?: string, senderId?: string, startDate?: Date, endDate?: Date, startIndex?: number, count?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {








        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }
        if (searchWord !== undefined && searchWord !== null) {
            queryParameters = queryParameters.set('searchWord', <any>searchWord);
        }
        if (senderId !== undefined && senderId !== null) {
            queryParameters = queryParameters.set('senderId', <any>senderId);
        }
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate.toISOString());
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate.toISOString());
        }
        if (startIndex !== undefined && startIndex !== null) {
            queryParameters = queryParameters.set('startIndex', <any>startIndex);
        }
        if (count !== undefined && count !== null) {
            queryParameters = queryParameters.set('count', <any>count);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<BatchSmsJobDto>(`${this.basePath}/api/BatchSmsJob/GetAll`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param stringidfiedId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public batchSmsJobGetById(stringidfiedId?: string, observe?: 'body', reportProgress?: boolean): Observable<BatchSmsJob>;
    public batchSmsJobGetById(stringidfiedId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BatchSmsJob>>;
    public batchSmsJobGetById(stringidfiedId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BatchSmsJob>>;
    public batchSmsJobGetById(stringidfiedId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (stringidfiedId !== undefined && stringidfiedId !== null) {
            queryParameters = queryParameters.set('stringidfiedId', <any>stringidfiedId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<BatchSmsJob>(`${this.basePath}/api/BatchSmsJob/GetById`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public batchSmsJobUpdate(model: BatchSmsJob, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public batchSmsJobUpdate(model: BatchSmsJob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public batchSmsJobUpdate(model: BatchSmsJob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public batchSmsJobUpdate(model: BatchSmsJob, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling batchSmsJobUpdate.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<boolean>(`${this.basePath}/api/BatchSmsJob/Update`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
